'use client';

import Image from '@/components/Image';
import { useValidExposure } from '@/hooks/useValidExposure';
import { SeedingItem } from '@/app/(activity)/campaigns/[slug]/types';
import { getSeedingCommentText } from '../utils/normalizeSeedingComment';
import { memo } from 'react';
import { env } from '@/utils/env';

interface SeedingItemCardProps {
  item: SeedingItem;
  index: number;
  isWap: boolean;
  columnCount: number;
  onClick: () => void;
  onExposure?: () => void;
}

function SeedingItemCard({ item, isWap, columnCount, onClick, onExposure }: SeedingItemCardProps) {
  const { ref: expRef } = useValidExposure({
    callback: () => onExposure?.(),
    ts: item.id || item.item_id || item.product_id,
  });

  const coverImage = item.material?.path ? `${env.NEXT_PUBLIC_S3_URL}${item.material?.path}` : '';
  const kolName = item.kol_name || '';
  const comment = getSeedingCommentText(item.comment);
  const productName = item.product_name || '';

  if (!coverImage) return null;

  return (
    <div ref={expRef} className="group w-full cursor-pointer overflow-hidden" onClick={onClick}>
      <div className="relative w-full overflow-hidden rounded-[8px]">
        <Image
          src={coverImage}
          alt={comment || productName || 'seeding item'}
          width={0}
          height={0}
          sizes={isWap ? '(max-width: 768px) 50vw, 25vw' : `${Math.ceil(100 / columnCount)}vw`}
          className="w-full h-auto object-cover"
          style={{
            aspectRatio:
              item.cover_width && item.cover_height
                ? `${item.cover_width}/${item.cover_height}`
                : undefined,
          }}
        />

        {kolName && (
          <div className="absolute bottom-[8px] right-[8px]">
            <span
              className={`text-primary-text font-br px-[4px] flex items-center justify-center text-[10px] ${isWap ? 'bg-white/40 h-[14px] rounded-[7px]' : 'bg-white/60 h-[16px] rounded-[8px]'}`}
            >
              @{kolName}
            </span>
          </div>
        )}
      </div>

      {comment && (
        <div>
          <p
            className={`text-primary-text font-br leading-[18px] mt-[12px] ${isWap ? 'text-[13px] line-clamp-2' : 'text-[14px] line-clamp-2'}`}
          >
            {comment}
          </p>
        </div>
      )}
    </div>
  );
}

export default memo(SeedingItemCard);
